import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

import { noColumnStyle } from '../../../utils/constants/tables';
import ActionsTableMenu from '../Components/ActionsTableMenu/ActionsTableMenu';

export type SortingMachinesType = {
  id: number;
  name: string;
  hubId: number;
  hubName: string;
  sortMapId: boolean;
  sortMapName: boolean;
  maxPorts: number;
  maps: { id: number; name: string; active: boolean }[];
  employeeId: number | null;
  employeeName: string | null;
};

export const tableStorageKey = 'sorting_machines_dataTable';

export function getColumnHeadersMap(t: TFunction) {
  return {
    no: t('No.'),
    name: t('Name'),
    maxPorts: t('Max Ports'),
  };
}

export function additionalColumnProperties(
  t: TFunction,
  column: keyof ReturnType<typeof getColumnHeadersMap> | 'actions',
  setContextMenuSelection: Dispatch<SetStateAction<any>>,
  setAction: (t: string) => void,
  setCaller: Dispatch<SetStateAction<'context-menu' | 'group-actions'>>,
  readGuard: boolean,
  editGuard: boolean,
  deleteGuard: boolean,
  readGuardMaps: boolean
) {
  switch (column) {
    case 'no':
      return {
        noColumnStyle,
        style: {
          width: 30,
          maxWidth: 30,
        },
        bodyStyle: {
          width: 30,
          maxWidth: 30,
          display: 'flex',
          textAlign: 'center',
        },
      };

    case 'name':
    case 'maxPorts':
      return {
        style: { width: 350 },
        bodyStyle: { width: 350 },
      };

    case 'actions':
      return {
        body: (row: SortingMachinesType) => {
          return (
            <ActionsTableMenu
              actions={[
                {
                  label: t('View Details'),
                  icon: 'fas fa-search',
                  disabled: !readGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('view-details');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Edit'),
                  icon: 'fas fa-edit',
                  disabled: !editGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('edit');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Change active sorting map'),
                  icon: 'fas fa-map-signs',
                  command: () => {},
                  disabled: row?.maps?.length === 0,
                  items: row?.maps?.map((map) => ({
                    command: () => {
                      setContextMenuSelection({
                        sortMapId: map.id,
                        id: row.id,
                      });
                      setAction('active-sorting-map');
                    },
                    label: map.name,
                    icon: map.active ? 'fas fa-check' : '',
                    className: 'p-0 m-0',
                  })),
                },
                {
                  label: t('Sorting Maps'),
                  icon: 'fas fa-map-signs',
                  disabled: !readGuardMaps,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('sorting-maps');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Delete'),
                  icon: 'fas fa-times',
                  disabled: !deleteGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setCaller('context-menu');
                    setAction('delete');
                  },
                },
              ]}
            />
          );
        },
        style: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
        },
        bodyStyle: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
          justifyContent: 'center',
        },
      };

    default:
      return {};
  }
}
